var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.362 4.73602C14.3718 4.87714 14.3717 5.01814 14.3717 5.16052C14.3717 9.49802 11.0696 14.5005 5.03175 14.5005V14.498C3.24801 14.5005 1.50124 13.9896 0 13.0263C0.259375 13.0575 0.52 13.0731 0.78125 13.0738C2.25964 13.075 3.6955 12.5791 4.85813 11.6659C4.17312 11.653 3.50928 11.4263 2.95943 11.0175C2.40957 10.6088 2.00119 10.0385 1.79138 9.38627C2.2835 9.48127 2.7905 9.46164 3.2735 9.32964C1.742 9.02027 0.64025 7.67477 0.64025 6.11214V6.07052C1.09679 6.32485 1.60776 6.46577 2.13013 6.48139C0.6875 5.51739 0.243125 3.59852 1.11413 2.09839C1.93824 3.11247 2.96645 3.94186 4.13198 4.53268C5.29751 5.1235 6.57428 5.46253 7.87937 5.52777C7.74929 4.96761 7.76854 4.38312 7.93521 3.83275C8.10188 3.28237 8.41013 2.78539 8.82913 2.39152C10.1513 1.14864 12.2306 1.21239 13.4734 2.53389C14.2085 2.38873 14.9135 2.1192 15.558 1.73689C15.3129 2.49698 14.8001 3.14219 14.115 3.55252C14.7657 3.4758 15.4012 3.30155 16 3.03564C15.5595 3.69535 15.0048 4.27116 14.362 4.73602Z",
    fill: "#1D9BF0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.11c077e8285e076238af4a2d9ea49c55.svg";
export { ForwardRef as ReactComponent };